import React from 'react';
interface AuroraBackgroundProps {
  children: ReactNode;
  className?: string;
}
export const AuroraBackground = ({
  children,
  className = ''
}: AuroraBackgroundProps) => {
  return <div className={`relative ${className}`} data-id="element-9">
      <div className="absolute inset-0 overflow-hidden" data-id="element-10">
        <div className={`
          absolute -inset-[10px] opacity-60 will-change-transform
          [--white-gradient:repeating-linear-gradient(100deg,var(--white)_0%,var(--white)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--white)_16%)]
          [--aurora:repeating-linear-gradient(100deg,var(--green-500)_10%,var(--green-300)_15%,var(--emerald-200)_20%,var(--green-400)_25%)]
          [background-image:var(--aurora)]
          [background-size:200%_200%]
          [background-position:50%_0%]
          filter blur-[60px] md:blur-[80px]
          after:content-[""] 
          after:absolute 
          after:inset-0 
          after:[background-image:var(--aurora)]
          after:[background-size:200%_100%] 
          after:animate-aurora 
          after:[background-attachment:fixed] 
          after:mix-blend-difference
          pointer-events-none
          md:[mask-image:radial-gradient(ellipse_at_100%_0%,black_10%,var(--transparent)_70%)]
          [mask-image:radial-gradient(ellipse_at_50%_0%,black_20%,var(--transparent)_70%)]
        `} data-id="element-11"></div>
      </div>
      {children}
    </div>;
};